import CodeBlock from './CodeBlock';


CodeBlock.install = function(Vue) {
  Vue.component(CodeBlock.name, CodeBlock);
};

export default CodeBlock;
